import { trackPromise } from 'react-promise-tracker'
import { setFilter } from '../../redux/actions'
import { Toast } from '../index'
import { defaultFilter } from '../variables'
import log from 'loglevel'
import moment from 'moment'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const UnSelectAll = (activeCaptures) => {
  activeCaptures = []
  const items = document.getElementsByClassName('checkbox-input')
  for (let i = 0; i < items.length; i++) {
    if (items[i].type === 'checkbox') {
      items[i].checked = false
    }
  }
}

// adds class for slide animation to trigger when moving to next page
export const slideNext = () => {
  document.getElementById('violationContainer').classList.add('slideLeftAnimation')
}

// adds class for slide animation to trigger when moving to previous page
export const slidePrevious = () => {
  document.getElementById('violationContainer').classList.add('slideRightAnimation')
}

// removes class for slide animation so it can be triggered again on page change
export const clearClass = () => {
  document.getElementById('violationContainer').classList.remove('slideLeftAnimation')
}

export const getTemplate = async (token, accountId) => {
  const options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'text/csv',
      Authorization: `Bearer ${token}`
    }
  }

  const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/file/template`, options))
  if (response.status === 500 || !response.status || response.status === 401) {
    return ''
  } else {
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    return url
  }
}

export const onQuickFilter = (map, dispatch, Filter) => {
  // When quick filtering, be sure to remove the fastFilterID
  const filter = { ...Filter, fastFilterID: '' }
  log.debug(defaultFilter)
  const keys = Object.keys(map)
  if (keys && keys.length > 0) {
    const key = keys[0]
    // for fields that allow multiple selections we always want to use arrays
    switch (key) {
      case 'applicationName':
        filter.applications = [map[key]]
        break
      case 'categoryName':
        filter.categories = [map[key]]
        break
      case 'username':
        filter.usernames = [map[key]]
        break
      case 'workstationName':
        filter.workstations = [map[key]]
        break
      default:
        filter[key] = map[key]
        break
    }
  }
  // handle filtering here
  handleFilter(filter, dispatch)
}

export const handleFilter = async (filter, dispatch) => {
  dispatch(setFilter(filter))
  Toast.fire({
    icon: 'success',
    title: 'Advanced Filter applied.'
  })
}

// Checks capture reportedAt timestamp against startTime and endTime from Filter to make sure they're within the given time frame
export const compareTime = (machineTime, startTime, endTime) => {
  if (!startTime || !endTime || startTime === 0 || endTime === 0) { return true }

  const momentStart = moment.isMoment(moment(startTime)) ? moment(startTime) : null
  const momentEnd = moment.isMoment(moment(endTime)) ? moment(endTime) : null

  if (!momentStart || !momentEnd) { return true }
  const startHour = momentStart.hour() * 100
  const startMinute = momentStart.minute()
  const endHour = momentEnd.hour() * 100
  const endMinute = momentEnd.minute()
  const machineMoment = moment(machineTime)
  const machineHour = machineMoment.hour() * 100
  const machineMinute = machineMoment.minute()

  return ((machineHour + machineMinute) >= (startHour + startMinute)) && ((machineHour + machineMinute) <= (endHour + endMinute))
}

export const convertToTimeArray = (startDate = 0, startTime = 0, endDate = 0, endTime = 0) => {
  if (!startDate || !startTime || !endTime) { return [] }
  if (!parseInt(startDate) || !parseInt(endDate) || endDate < 0 || !parseInt(startTime) || !endTime) { return [] }
  // Use moment to get starting values
  const startDay = moment(startDate)
  const endDay = moment(endDate)
  const startMinute = moment(startTime).minute()
  const startHour = moment(startTime).hour()
  const endMinute = moment(endTime).minute()
  const endHour = moment(endTime).hour()
  // Get the total difference in days between the end and start dates
  const days = endDate ? endDay.diff(startDay, 'd') : 0
  const timeArray = []
  // Loop through the number of days, add that to the beginning along with the proper time for start and end
  for (var i = 0; i <= days; i++) {
    const newStartDate = startDay.clone().add(i, 'd').add(startHour, 'h').add(startMinute, 'm')
    const newEndDate = startDay.clone().add(i, 'd').add(endHour, 'h').add(endMinute, 'm')
    timeArray.push({ start: newStartDate.valueOf(), end: newEndDate.valueOf() })
  }
  return timeArray
}
